import { ColumnsConfig } from "./ColumnsConfig";

const Config = {
	initialColumns: {
		reviewReport: [
			"review_subject",
			"employee_Group",
			"reviewcycle_name",
			"review_name",
			"reviewform_name",
			"reviewform_authors",
			"reviewform_signers",
		],
		employeeReport: ["employee_Employee", "employee_Email", "employee_Manager", "employee_Group"],
		goalReport: [
			"employee_Manager",
			"goal_assignee",
			"goal_name",
			"goal_last_status_update",
			"goal_categories",
			"goal_end_date",
			"goal_outlook",
			"goal_value",
			"goal_current_progress",
			"goal_transparency",
		],
		surveyReport: [
			"employee_Manager",
			"survey_name",
			"survey_status",
			"survey_start_date",
			"survey_end_date",
			"survey_participant_name",
			"survey_participant_submitted_date",
		],
	},
	defaultColumnData: {
		employeeFields: [],
		reviewFields: [
			{
				headerName: "Review Subject",
				field: "subject",
				sortable: false,
				pinned: "left",
				fieldValueType: "person",
				cellClass: "ag-grid-cell",
				headerClass: "ag-grid-header",
			},
			{
				headerName: "Review Cycle",
				field: "review_cycle",
				sortable: false,
				fieldValueType: "reviewCycle",
				cellClass: "ag-grid-cell",
				headerClass: "ag-grid-header",
			},
			{
				headerName: "Review",
				field: "review",
				sortable: false,
				cellClass: "ag-grid-cell",
				fieldValueType: "text",
				headerClass: "ag-grid-header",
			},
			{
				headerName: "Review Template",
				field: "review_template",
				sortable: false,
				fieldValueType: "reviewTemplate",
				cellClass: "ag-grid-cell",
				headerClass: "ag-grid-header",
			},
			{
				headerName: "Authors",
				field: "authors",
				sortable: false,
				fieldValueType: "people",
				cellClass: "ag-grid-cell",
				headerClass: "ag-grid-header",
			},
		],
		uniqueQuestions: [],
		groupedQuestions: [],
	},
	defaultColumnMetaData: {
		width: 200,
	},
	...ColumnsConfig,
	groupLabelLookup: {
		EMPLOYEE_FIELD: "Employee Fields",
		REVIEW_FIELD: "Review Fields",
		REVIEW_CYCLE_FIELD: "Review Cycle Fields",
		REVIEW_FORM_FIELD: "Review Form Fields",
		SURVEY_FIELD: "Survey Fields",
		QUESTION_GROUPS: "Question Groups",
		GOAL_FIELD: "Goal Fields",
	},
	fieldGroupLookup: {
		employee: "EMPLOYEE_FIELD",
		review: "REVIEW_FIELD",
		reviewcycle: "REVIEW_CYCLE_FIELD",
		reviewform: "REVIEW_FORM_FIELD",
		question: "UNIQUE_QUESTION",
		groupedquestion: "GROUPED_QUESTION",
		goal: "GOAL_FIELD",
		survey: "SURVEY_FIELD",
	},
	// default summarize row fields
	summarizeFields: {
		goal: [
			{
				value: "goal_assignee",
				label: "Assignee",
				group: "GOAL_FIELD",
				type: "person",
			},
			{
				value: "goal_end_date",
				label: "Due Date",
				group: "GOAL_FIELD",
				type: "date",
			},
			{
				value: "goal_status",
				label: "Status",
				group: "GOAL_FIELD",
				type: "goalStatus",
			},
		],
		employee: [
			{
				value: "employee_Group",
				label: "Employee Group",
				group: "EMPLOYEE_FIELD",
				type: "department",
			},
			{
				value: "employee_Manager",
				label: "Manager",
				group: "EMPLOYEE_FIELD",
				type: "person",
			},
			{
				value: "employee_Hire Date",
				label: "Hire Date",
				group: "EMPLOYEE_FIELD",
				type: "date",
			},
			{
				value: "employee_Termination Date",
				label: "Termination Date",
				group: "EMPLOYEE_FIELD",
				type: "date",
			},
		],
		reviewcycle: [
			{
				value: "reviewcycle_name",
				label: "Review Cycle Name",
				group: "REVIEW_CYCLE_FIELD",
				type: "reviewCycle",
			},
			{
				value: "reviewcycle_status",
				label: "Review Cycle Status",
				group: "REVIEW_CYCLE_FIELD",
				type: "reviewCycleStatus",
			},
			{
				value: "reviewcycle_start_date",
				label: "Review Cycle Start Date",
				group: "REVIEW_CYCLE_FIELD",
				type: "date",
			},
		],
		review: [
			{
				value: "review_subject",
				label: "Review Subject",
				group: "REVIEW_FIELD",
				type: "person",
			},
			{
				value: "review_status",
				label: "Review Status",
				group: "REVIEW_FIELD",
				type: "text",
			},
			{
				value: "review_start_date",
				label: "Review Start Date",
				group: "REVIEW_FIELD",
				type: "date",
			},
			{
				value: "review_completed_date",
				label: "Review Completed Date",
				group: "REVIEW_FIELD",
				type: "date",
			},
		],
		reviewform: [
			{
				value: "reviewform_name",
				label: "Review Form Name",
				group: "REVIEW_FORM_FIELD",
				type: "text",
			},
			{
				value: "reviewform_status",
				label: "Review Form Status",
				group: "REVIEW_FORM_FIELD",
				type: "reviewFormStatus",
			},
			{
				value: "reviewform_signers_due_date",
				label: "Review Form Signer Due Date",
				group: "REVIEW_FORM_FIELD",
				type: "date",
			},
			{
				value: "reviewform_authors_due_date",
				label: "Review Form Author Due Date",
				group: "REVIEW_FORM_FIELD",
				type: "date",
			},
			{
				value: "reviewform_completed_date",
				label: "Review Form Completed Date",
				group: "REVIEW_FORM_FIELD",
				type: "date",
			},
			{
				value: "reviewform_current_author",
				label: "Review Form Current Author",
				group: "REVIEW_FORM_FIELD",
				type: "person",
			},
			{
				value: "reviewform_current_signer",
				label: "Review Form Current Signer",
				group: "REVIEW_FORM_FIELD",
				type: "person",
			},
		],
		survey: [
			{
				value: "survey_name",
				label: "Name",
				group: "SURVEY_FIELD",
				type: "text",
			},
			{
				value: "survey_participant",
				label: "Participant",
				group: "SURVEY_FIELD",
				type: "text",
			},
			{
				value: "survey_status",
				label: "Status",
				group: "SURVEY_FIELD",
				type: "text",
			},
			{
				value: "survey_start_date",
				label: "Start Date",
				group: "SURVEY_FIELD",
				type: "date",
			},
			{
				value: "survey_end_date",
				label: "End Date",
				group: "SURVEY_FIELD",
				type: "date",
			},
		],
	},
	numericTypes: ["numeric", "rating-scale", "calculator", "monetary", "salary", "goalProgress"],
	textTypes: ["multiline", "text"],
	selectTypes: ["multiple-choice", "multiple-select"],
	dateTypes: ["date"],
	dateSummarizeByOptions: ["year", "month", "quarter"],
	binSummarizeByOptions: ["automatic", 5, 10, 25],
	binnableTypes: ["numeric", "monetary", "salary", "groupedquestion"],
};

export default Config;
